"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactMapGl = _interopRequireWildcard(require("react-map-gl"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FontAwesome = _interopRequireDefault(require("../../Icon/FontAwesome"));

var _Base = _interopRequireDefault(require("../Base"));

var _constants = require("./constants");

var _Pin = _interopRequireDefault(require("./Pin"));

var _SideBar = _interopRequireDefault(require("./SideBar"));

require("./style.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Map Moment to integrate a `story` with _OpenStreetMaps_.
 */
var MapMoment =
/*#__PURE__*/
function (_Component) {
  _inherits(MapMoment, _Component);

  function MapMoment(props) {
    var _this;

    _classCallCheck(this, MapMoment);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MapMoment).call(this, props));
    _this.state = {
      currentLocation: null,
      sidebar: true,
      tooltip: null,
      viewport: {
        // TODO: Make default zoom shrink to fix bounds of points
        latitude: 37.785164,
        longitude: -100,
        zoom: 1
      }
    };
    _this.handleSelectLocation = _this.handleSelectLocation.bind(_assertThisInitialized(_this));
    _this.handleSidebarToggle = _this.handleSidebarToggle.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MapMoment, [{
    key: "handleSelectLocation",
    value: function handleSelectLocation(location) {
      this.setState({
        currentLocation: location,
        tooltip: location.label,
        viewport: {
          latitude: location.coordinates.latitude,
          longitude: location.coordinates.longitude,
          transitionInterpolator: new _reactMapGl.FlyToInterpolator({
            speed: 2
          }),
          transitionDuration: 'auto',
          zoom: 11
        }
      });
    }
  }, {
    key: "handleSidebarToggle",
    value: function handleSidebarToggle() {
      this.setState({
        sidebar: !this.state.sidebar
      });
    }
  }, {
    key: "renderTooltip",
    value: function renderTooltip() {
      var _this2 = this;

      var _this$state = this.state,
          currentLocation = _this$state.currentLocation,
          tooltip = _this$state.tooltip;
      return tooltip && _react.default.createElement(_reactMapGl.Popup, {
        tipSize: 5,
        anchor: "top",
        longitude: currentLocation.coordinates.longitude,
        latitude: currentLocation.coordinates.latitude,
        closeOnClick: false,
        onClose: function onClose() {
          return _this2.setState({
            tooltip: null
          });
        }
      }, currentLocation.label);
    }
  }, {
    key: "renderMarkers",
    value: function renderMarkers() {
      var _this3 = this;

      var data = this.props.data;
      return data.map(function (location, index) {
        return _react.default.createElement(_reactMapGl.Marker, {
          key: "marker-".concat(index),
          longitude: location.coordinates.longitude,
          latitude: location.coordinates.latitude
        }, _react.default.createElement(_Pin.default, {
          size: 10 + (location.details && location.details.length * 20),
          onClick: function onClick() {
            return _this3.handleSelectLocation(location);
          }
        }));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var handleSelectLocation = this.handleSelectLocation,
          handleSidebarToggle = this.handleSidebarToggle;
      var data = this.props.data;
      var _this$state2 = this.state,
          currentLocation = _this$state2.currentLocation,
          sidebar = _this$state2.sidebar,
          viewport = _this$state2.viewport;
      var layout = "map"; // TODO: Add constant

      return _react.default.createElement(_Base.default, _extends({}, this.props, {
        layout: layout
      }), _react.default.createElement(_SideBar.default, {
        currentLocation: currentLocation,
        data: data,
        onSelect: handleSelectLocation,
        open: sidebar
      }, _react.default.createElement("div", {
        className: "map-wrapper"
      }, _react.default.createElement(_reactMapGl.default, _extends({
        height: "100%",
        width: "100%",
        mapStyle: _constants.mapStyle
      }, viewport, {
        onViewportChange: function onViewportChange(viewport) {
          return _this4.setState({
            viewport: viewport
          });
        }
      }), this.renderMarkers(), this.renderTooltip(), _react.default.createElement("div", {
        className: "fullscreen",
        style: _constants.fullscreenControlStyle
      }, _react.default.createElement(_reactMapGl.FullscreenControl, null)), _react.default.createElement("div", {
        style: _constants.sideBarControlStyle
      }, _react.default.createElement("div", {
        className: "mapboxgl-ctrl mapboxgl-ctrl-group"
      }, _react.default.createElement("button", {
        className: "mapboxgl-ctrl-icon",
        onClick: handleSidebarToggle,
        type: "button",
        title: "Toggle Info Panel"
      }, _react.default.createElement(_FontAwesome.default, {
        name: "FaMapSigns"
      })))), _react.default.createElement("div", {
        className: "nav",
        style: _constants.navStyle
      }, _react.default.createElement(_reactMapGl.NavigationControl, null))))));
    }
  }]);

  return MapMoment;
}(_react.Component);

exports.default = MapMoment;

_defineProperty(MapMoment, "propTypes", {
  /** Determines the background and text color of the `Moment` header. */
  color: _propTypes.default.shape({
    background: _propTypes.default.string,
    text: _propTypes.default.string
  }),

  /** Stories-API data context to configure the `MapMarker`s. */
  data: _propTypes.default.arrayOf(_propTypes.default.shape({
    coordinates: _propTypes.default.shape({
      latitude: _propTypes.default.number.isRequired,
      longitude: _propTypes.default.number.isRequired,
      point: _propTypes.default.arrayOf(_propTypes.default.number.isRequired).isRequired
    }).isRequired,
    label: _propTypes.default.string,
    details: _propTypes.default.arrayOf(_propTypes.default.object)
  })),

  /** Determines the `SideBarSection` `Icon` of the `Moment`. */
  icon: _propTypes.default.element,

  /** Used to serialize the order of the `Moment`s in a `Story` */
  index: _propTypes.default.number,

  /** Determines the `SideBarSection` text of the `Moment`. */
  label: _propTypes.default.string,

  /** Paragraph text underneath the title in `Moment` header */
  subtitle: _propTypes.default.string,

  /** Main heading element of the `Moment` */
  title: _propTypes.default.node,

  /** The type of `Moment` */
  type: _propTypes.default.string
});

_defineProperty(MapMoment, "defaultProps", {
  type: "map",
  data: []
});